const PORTAL_LOGOUT_STORAGE_KEYS = ['formioToken', 'tokenExpiration', 'formioUser'] as const;

/**
 * Removes portal Formio auth artifacts from local storage.
 * Call this before logout to prevent stale Formio state after sign-out.
 */
export function clearPortalLogoutStorage(storage: Storage): void {
  for (const key of PORTAL_LOGOUT_STORAGE_KEYS) {
    storage.removeItem(key);
  }
}
